import { render, staticRenderFns } from "./LearnerDetail.vue?vue&type=template&id=46a352a5&scoped=true&"
import script from "./LearnerDetail.vue?vue&type=script&lang=js&"
export * from "./LearnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./LearnerDetail.vue?vue&type=style&index=0&id=46a352a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a352a5",
  null
  
)

export default component.exports